import React, { useEffect, useState } from "react";
import { MdOutlineSearch } from "react-icons/md";

const AdminSearchBar = ({ title, onAddNewClick, onSearchClick }) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchQuery.trim());
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  useEffect(() => {
    onSearchClick(debouncedQuery);
  }, [debouncedQuery]);

  return (
    <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4 py-4 px-4 sm:px-6 bg-gray-100 shadow-sm rounded-md mb-4">
      <h1 className="text-xl sm:text-2xl font-bold text-primaryTextColor">
        {title}
      </h1>

      <form
        onSubmit={(e) => e.preventDefault()}
        className="flex  sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3 w-full md:w-auto"
      >
        <div className="relative flex grow items-center">
          <span className="absolute inset-y-0 left-0 flex items-center pl-3 text-gray-500">
            <MdOutlineSearch size={20} />
          </span>

          <input
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search..."
            enterKeyHint="search"
            className="pl-10 pr-10 py-2 w-full border border-gray-300 rounded outline-primaryColor placeholder:font-medium"
          />

          {searchQuery.length > 0 && (
            <button
              type="button"
              onClick={() => setSearchQuery("")}
              className="absolute right-3 text-gray-500 hover:text-red-500 transition-colors duration-150"
              title="Clear"
            >
              &#x2715;
            </button>
          )}
        </div>

        <button
          type="button"
          onClick={onAddNewClick}
          className="bg-primaryBtnColor text-white px-4 py-2  rounded hover:bg-primaryBtnHoverColor whitespace-nowrap font-bold box-border text-center"
        >
          + Add New
        </button>
      </form>
    </div>
  );
};

export default AdminSearchBar;
